module.exports = {"dccv2":{}}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/dcc-widget-v2/src/intl.json
// module id = 782
// module chunks = 2